mutation RESTORE_VEHICLE($id: UUID!) {
  restoreVehicle(id: $id) {
    success
    error
  }
}
